import { CountryId } from '../country/CountryId'
import { Codebook } from '../Codebook'

/** Mirrors `Previo_Country_CountryConfig::getCountryChildAge()` */
export class CountryChildAge extends Codebook<CountryId> {
  static readonly HUN = new CountryChildAge(CountryId.HUN, 14)

  static readonly DEFAULT_AGE = 15

  private constructor(
    id: CountryId,
    public readonly age: number,
  ) {
    super(id)
  }

  static isChildAge = (propertyCountryId: CountryId | null, ageInYears: number): boolean => {
    return ageInYears < CountryChildAge.limitFor(propertyCountryId)
  }

  private static limitFor = (propertyCountryId: CountryId | null): number => {
    if (propertyCountryId === null || !CountryChildAge.contains(propertyCountryId)) {
      return CountryChildAge.DEFAULT_AGE
    }

    return CountryChildAge.getById(propertyCountryId).age
  }
}
